export default __webpack_public_path__ + "static/0042-8f084e8b8c6e0f459b73c7e720e318b2.png";